// extracted by mini-css-extract-plugin
module.exports = {"userMenuIcon":"UserMenu_userMenuIcon__zhRWf"};